class LineChart
    constructor: (el) ->
        @.$el = el
        @.$dataEl = @.$el.querySelector '.line-chart__data'
        @.$labelsEl = @.$el.querySelector '.line-chart__y-axis-labels'
        @.$labels = if @.$labelsEl then @.$labelsEl.querySelectorAll '.line-chart__y-axis-label' else []
        @.$labelsMobileEl = @.$el.querySelector '.line-chart__mobile__y-axis-labels'
        @.$linesSvg = @.$el.querySelector '.line-chart__lines'
        @.$linesMobileGroup = @.$el.querySelector '.line-chart__mobile__lines g'
        @.$pointsSvg = @.$el.querySelector '.line-chart__points'
        @.$pointsMobileGroup = @.$el.querySelector '.line-chart__mobile__points g'

        @.data = []

        @.GetData()
        @.CreateChart()
        @.$el.classList.add 'line-chart--bound'
        return
    
    CreateChart: ->
        self = @
        if @.data.length > 0
            polylineEl = document.createElementNS 'http://www.w3.org/2000/svg', 'polyline'
            polylineElMobile = document.createElementNS 'http://www.w3.org/2000/svg', 'polyline'
            points = ""
            pointsMobile = ""
            @.data.forEach (dataPoint) ->
                if dataPoint.x >= 0 && dataPoint.y >= 0 
                    circleEl = document.createElementNS 'http://www.w3.org/2000/svg', 'circle'
                    circleElMobile = document.createElementNS 'http://www.w3.org/2000/svg', 'circle'
                    circleEl.setAttribute 'cx', dataPoint.x + '%'
                    circleElMobile.setAttribute 'cx', (dataPoint.y * 2)
                    circleEl.setAttribute 'cy', (100 - dataPoint.y) + '%'
                    circleElMobile.setAttribute 'cy', (dataPoint.x * 3.6)
                    circleEl.setAttribute 'r', "1.5%"
                    circleElMobile.setAttribute 'r', "1.5%"
                    if dataPoint.text
                        circleEl.innerHTML = "
                            <title>#{ dataPoint.text }</title>
                        "
                        circleElMobile.innerHTML = "
                            <title>#{ dataPoint.text }</title>
                        "
                    self.$pointsSvg.appendChild circleEl
                    self.$pointsMobileGroup.appendChild circleElMobile
                    points += dataPoint.x + "," + (100 - dataPoint.y) + " "
                    pointsMobile += "#{ dataPoint.y * 2 },#{ dataPoint.x * 3.6 } "
                return
            @.$labels.forEach (labelEl) ->
                mobileLabelEl = document.createElement 'div'
                mobileLabelEl.classList.add 'line-chart__y-axis-label'
                mobileLabelEl.innerHTML = labelEl.innerHTML
                if labelEl.dataset?.x
                    labelEl.style.left = "#{ labelEl.dataset.x }%"
                    mobileLabelEl.style.top = "#{ labelEl.dataset.x }%"
                if labelEl.dataset?.transform
                    labelEl.style.transform = labelEl.dataset.transform
                if labelEl.dataset?.transformMobile
                    mobileLabelEl.style.transform = labelEl.dataset.transformMobile
                self.$labelsMobileEl.appendChild mobileLabelEl
                return
            polylineEl.setAttribute 'points', points.slice(0,-1)
            polylineElMobile.setAttribute 'points', pointsMobile.slice(0,-1)
            polylineEl.setAttribute 'vector-effect','non-scaling-stroke'
            polylineElMobile.setAttribute 'vector-effect','non-scaling-stroke'
            @.$linesSvg.appendChild polylineEl
            @.$linesMobileGroup.appendChild polylineElMobile
        else
            @.$el.remove()
        return

    GetData: ->
        self = @
        @.$dataEl.querySelectorAll 'li'
            .forEach (el) ->
                x = el.dataset?.x ? false
                y = el.dataset?.y ? false
                text = if el.textContent? != "" then el.textContent else false
                if x && y
                    dataPoint = {
                        x: x,
                        y: y
                    }
                    if text
                        dataPoint.text = text
                    self.data.push dataPoint
                return
        return
    
BindLineCharts = ->
    document.querySelectorAll '.line-chart:not(.line-chart--bound)'
        .forEach (el) ->
            new LineChart el
            return
    return

window.addEventListener 'bind-components', BindLineCharts